import { html, LitElement } from 'lit';
import { TagKey } from '@cof/tag-catalog-fs-personal-mfe';
import { DebugService } from '../../../../shared/services/debug.service.js';
import { style } from './edit-name.style.js';
import { stratum } from '../../../../../constants/stratum.js';

class RefiEditName extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiEditName');
  }

  static properties = {
    applicant: { type: Object, reflect: true },
  };

  static styles = [style];

  render() {
    return html` <div class="checkout-name-edit">
      <fs-text-field
        class="first-name"
        id="checkout-first-name-edit"
        autocomplete="given-name"
        name="personalName.firstName"
        type="text"
        value-missing-message="Please enter your legal first name"
        maxLength="32"
        pattern="(([ \\-]*)?[A-Za-z]+([ \\-]*)?)*"
        required
        @change="${(ev) => this.changed('firstName', ev)}"
        @blur="${(ev) => {
          this.dispatchEvent(new CustomEvent('unsaved-fields'));
          if (ev.target.validity.valid) {
            stratum.publishTag(TagKey.PQ_TEXT_INPUT_FIELD_EDITED_FIELD, {
              replacements: { value: 'firstName' },
            });
          } else {
            stratum.publishTag(
              TagKey.PQ_TEXT_INPUT_FIELD_FIELD_VALIDATION_ERROR_MESSAGE,
              {
                replacements: {
                  value: 'Your first name cannot contain numbers or symbols',
                },
              }
            );
          }
        }}"
        value="${this.applicant.firstName}"
        pattern-mismatch-message="Your first name cannot contain numbers or symbols"
        autofocus
      >
        <slot name="firstName">First name</slot>
      </fs-text-field>

      <fs-text-field
        id="checkout-last-name-edit"
        autocomplete="family-name"
        name="personalName.lastName"
        type="text"
        value-missing-message="Please enter your legal last name"
        maxLength="32"
        pattern="(([ \\-]*)?[A-Za-z]+([ \\-]*)?[A-Za-z]+([ \\-]*)?)*"
        required
        @change="${(ev) => this.changed('lastName', ev)}"
        @blur="${(ev) => {
          this.dispatchEvent(new CustomEvent('unsaved-fields'));
          if (ev.target.validity.valid) {
            stratum.publishTag(TagKey.PQ_TEXT_INPUT_FIELD_EDITED_FIELD, {
              replacements: { value: 'lastName' },
            });
          } else {
            stratum.publishTag(
              TagKey.PQ_TEXT_INPUT_FIELD_FIELD_VALIDATION_ERROR_MESSAGE,
              {
                replacements: {
                  value: 'Your last name cannot contain numbers or symbols',
                },
              }
            );
          }
        }}"
        value="${this.applicant.lastName}"
        pattern-mismatch-message="Your last name cannot contain numbers or symbols"
      >
        <slot name="lastName">Last name</slot>
      </fs-text-field>
    </div>`;
  }

  changed(name, ev) {
    this.applicant[name] = ev?.target?.value.trim();
    this.dispatchEvent(
      new CustomEvent('validity', {
        detail: {
          name,
          isValid: ev.target.validity.valid,
        },
      })
    );
  }
}

customElements.define('refi-edit-name', RefiEditName);
